import React from 'react';
import PropTypes from 'prop-types';
import {PARKING_STATUS_OPTION} from 'Utils/constants';
import {PARKING_STATUSES} from 'Components/layouts/kiosk/kioskLayoutConstants';
import ParkingStatusLabel from './ParkingStatusLabel';

const showRateA = rates => {
    if (rates?.rate0?.rate < 1) {
        return '';
    }

    return `${rates.rate0.rate}/${rates.rate0.ratePeriod.toUpperCase()}`;
};

const ParkingLocationDetails = ({status, rates, parkingStatusMapping}) => (
    <div className="parking-status-details">
        {status && (
            <ParkingStatusLabel status={status} parkingStatusMapping={parkingStatusMapping} />
        )}
        {status?.toUpperCase() === PARKING_STATUSES.OPEN && (
            <span className="parking-info" aria-label="parking-info">
                {showRateA(rates)}
            </span>
        )}
    </div>
);

ParkingLocationDetails.propTypes = {
    status: PropTypes.oneOf(PARKING_STATUS_OPTION.map(status => status.name)).isRequired,
    rates: PropTypes.object,
    parkingStatusMapping: PropTypes.object,
};

export default ParkingLocationDetails;
